<template>
    <div class="items-quotation-filters">
        <app-sub-title text="Filtros" />
        <b-card>
            <div class="card-text">
                <b-row>
                    <b-col cols="12" md="3">
                        <app-form-text-input
                            placeholder="Nombre"
                            v-model="name"
                        />
                    </b-col>
                    <b-col cols="12" md="3">
                        <app-form-text-input
                            placeholder="Referencia"
                            v-model="reference"
                        />
                    </b-col>
                    <b-col cols="12" md="3">
                        <app-form-select-input
                            placeholder="Seleccione una categoría"
                            :options="categoryOptions"
                            v-model="category_id"
                        />
                    </b-col>
                    <b-col cols="12" md="3">
                        <app-form-select-input
                            placeholder="Estado"
                            :options="statusOptions"
                            v-model="status"
                        />
                    </b-col>
                    <b-col cols="12" md="3">
                        <app-form-select-input
                            placeholder="Moneda"
                            :options="currencyOptions"
                            v-model="currency"
                        />
                    </b-col>
                    <b-col cols="12" md="3">
                        <b-btn variant="primary" @click="filter" class="btn-block">
                            <i class="fa fa-filter"></i> Filtrar
                        </b-btn>
                    </b-col>
                    <b-col cols="12" md="3">
                        <b-btn variant="secondary" @click="clearFilters" class="btn-block">
                            <i class="fa fa-times-circle"></i> Limpiar
                        </b-btn>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>
<script>
import FormTextInput from '../../../UI/Controls/Forms/FormTextInput.vue';
import FormSelectInput from '../../../UI/Controls/Forms/FormSelectInput.vue';
import SubTitle from '../../../UI/Layout/SubTitle.vue';
import { getStatusOptions, getCurrencyOptions } from '../../../../utils/quotationOptions';

export default {
    components: {
        appFormTextInput: FormTextInput,
        appFormSelectInput: FormSelectInput,
        appSubTitle: SubTitle
    },
    props: {
        categories: {
            type: Array,
            default: () => []
        },
        onFilter: {
            type: Function,
            required: true
        },
        onClearFilters: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            name: '',
            reference: '',
            category_id: '',
            status: '',
            currency: '',
            statusOptions: getStatusOptions(),
            currencyOptions: getCurrencyOptions()
        };
    },
    computed: {
        categoryOptions() {
            const options = [];
            return options.concat(
                this.categories.map(cat => ({
                    id: cat.id,
                    name: this.formatCategoryName(cat.name, cat.slug)
                }))
            );
        }
    },
    methods: {
        formatCategoryName(name, slug) {

            const names = {
                slug: name
            };
            return names[slug] || name;
        },
        filter() {
            const filters = {};
            if (this.name) filters.name = this.name;
            if (this.reference) filters.reference = this.reference;
            if (this.category_id) filters.category_id = this.category_id;
            if (this.status !== '') filters.status = this.status === '1';
            if (this.currency) filters.currency = this.currency;
            this.onFilter(filters);
        },
        clearFilters() {
            this.name = '';
            this.reference = '';
            this.category_id = '';
            this.status = '';
            this.currency = '';
            this.onClearFilters();
        }
    }
};
</script>

